import React, { ReactNode } from "react";
import { arPreviewFromSearch, useArabicUi } from "@/shared/config/arabicUi";
import { RtlContext, RtlProviders } from "@/shared/lib/rtl/RtlProviders";
import { useArabicDocument } from "../lib/useArabicDocument";
import { ArabicPreviewParam } from "./ArabicPreviewParam";

/**
 * Арабский интерфейс вокруг всего сайта (App): только /ar и только когда он
 * включён — рубильником AR_UI_ENABLED или предпросмотром админа на этом
 * устройстве (shared/config/arabicUi). Тогда: <html lang="ar" dir="rtl">,
 * строки ar.json (чего нет — английский), MUI справа налево (свой кэш emotion
 * и тема direction: "rtl").
 *
 * Выключен — ровно сегодняшний сайт: <html> и i18next не трогаются, обёрток
 * MUI нет, ar.json не скачивается. ?ar_preview=… обрабатывается, только когда
 * он есть в адресе (иначе список админов ради него не запрашивается).
 */
export const ArabicUiShell: React.FC<{ pathname: string; search: string; children: ReactNode }> = ({
    pathname,
    search,
    children,
}) => {
    const arabic = useArabicUi((pathname || "/").split("/")[1]);
    useArabicDocument(arabic);
    return (
        <RtlContext.Provider value={arabic}>
            {arPreviewFromSearch(search) !== null && <ArabicPreviewParam search={search} />}
            {arabic ? <RtlProviders>{children}</RtlProviders> : children}
        </RtlContext.Provider>
    );
};
